const UPDATED = "Giugno 2026";

export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="data-deletion-page">
      <div className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mb-2">Cancellazione dei dati</h1>
        <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: {UPDATED}</p>

        <div className="space-y-6 text-[15px] leading-relaxed">
          <section>
            <p>Memento rispetta il tuo diritto alla cancellazione dei dati personali, inclusi i dati provenienti da
              WhatsApp e dalle piattaforme Meta.</p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-1">Come richiedere la cancellazione</h2>
            <p>Per richiedere la cancellazione dei tuoi dati personali, invia un'email a
              <b> info@salon-up.it</b> con oggetto <b>"Richiesta cancellazione dati"</b>, indicando:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>il nome del salone con cui hai avuto contatti;</li>
              <li>il numero di telefono/WhatsApp con cui sei stato contattato.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-1">Cosa cancelliamo</h2>
            <p>A seguito della richiesta cancelleremo: i tuoi dati di contatto, la cronologia delle conversazioni
              WhatsApp, le note e gli appuntamenti collegati al tuo profilo, salvo quanto debba essere conservato per
              obblighi di legge.</p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-1">Tempistiche</h2>
            <p>Elaboreremo la richiesta entro <b>30 giorni</b> e ti invieremo conferma dell'avvenuta cancellazione
              all'indirizzo email o al numero da cui è pervenuta la richiesta.</p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-1">Contatti</h2>
            <p>Per assistenza sulla cancellazione dei dati: <b>info@salon-up.it</b>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
